import Icon from '../components/Icon.vue'

Icon.register({
  'grin-beam': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM328 152C351.8 152 380.7 181.3 384 223.4 384.7 232 373.2 235.3 369.1 227.9L359.6 210.9C351.9 197.2 340.4 189.3 328.1 189.3S304.3 197.2 296.6 210.9L287.1 227.9C283 235.2 271.5 231.9 272.2 223.4 275.3 181.3 304.2 152 328 152zM168 152C191.8 152 220.7 181.3 224 223.4 224.7 232 213.2 235.3 209.1 227.9L199.6 210.9C191.9 197.2 180.4 189.3 168.1 189.3S144.3 197.2 136.6 210.9L127.1 227.9C122.9 235.3 111.5 231.9 112.2 223.4 115.3 181.3 144.2 152 168 152zM248 432C187.4 432 113.5 393.7 104.2 338.7 102.2 326.8 113.6 317.1 124.9 320.8 155.1 330.5 200 336 248 336S340.9 330.5 371.1 320.8C382.5 317.1 393.7 326.9 391.8 338.7 382.5 393.7 308.6 432 248 432z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin-beam.js
// module id = oA7M
// module chunks = 144